module.exports = __webpack_public_path__ + "img/goldregen-2020-102.4e10358c.jpg";